var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-form",
        { ref: "form", attrs: { size: "mini", "label-width": "70px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("panel.enable_jump") } },
            [
              _c("el-switch", {
                attrs: { size: "mini" },
                model: {
                  value: _vm.linkInfo.enable,
                  callback: function ($$v) {
                    _vm.$set(_vm.linkInfo, "enable", $$v)
                  },
                  expression: "linkInfo.enable",
                },
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.linkInfo.enable,
                      expression: "linkInfo.enable",
                    },
                  ],
                  staticStyle: {
                    color: "#909399",
                    "font-size": "8px",
                    "margin-left": "3px",
                  },
                },
                [
                  _vm._v(
                    "\n        Tips:" +
                      _vm._s(_vm.$t("panel.link_open_tips")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("panel.open_mode") } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: !_vm.linkInfo.enable },
                  model: {
                    value: _vm.linkInfo.openMode,
                    callback: function ($$v) {
                      _vm.$set(_vm.linkInfo, "openMode", $$v)
                    },
                    expression: "linkInfo.openMode",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "_blank" } }, [
                    _vm._v(_vm._s(_vm.$t("panel.new_window"))),
                  ]),
                  _c("el-radio", { attrs: { label: "_self" } }, [
                    _vm._v(_vm._s(_vm.$t("panel.now_window"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("panel.hyperLinks") } },
            [
              _c("el-input", {
                attrs: { disabled: !_vm.linkInfo.enable },
                model: {
                  value: _vm.linkInfo.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.linkInfo, "content", $$v)
                  },
                  expression: "linkInfo.content",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v(_vm._s(_vm.$t("panel.confirm")))]
              ),
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v(_vm._s(_vm.$t("panel.cancel"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }